export default "__VITE_ASSET__Boeo0drd__"